import Vuex from "vuex";
import Vue from "vue";
import VueResource from "vue-resource";
import VueI18n from 'vue-i18n';
import Vue2TouchEvents from 'vue2-touch-events'

import endproduktFinder from './app/endprodukt-finder'
import endproduktFnderStore from './store/endprodukt-finder-store'

export const endproduktFinderInit = {
    init: () => {
        const endproduktFinderShell = document.getElementById('endproduktfinder');

        if (endproduktFinderShell !== null) {
            Vue.use(VueResource);
            Vue.use(Vuex);
            Vue.use(VueI18n);
            Vue.use(Vue2TouchEvents);

            new Vue({
                store: endproduktFnderStore,
                render: h => h(endproduktFinder, {
                    props: {}
                }),
                i18n: new VueI18n({
                    locale: 'epf', // set locale
                    messages: window.EPF_I18N // set locale messages
                }),
            }).$mount('#endproduktfinder');
        }
    }
};

